module.exports = __webpack_public_path__ + "img/img_pc.b9402e6a.png";